import {
  FoodDetailsBody,
  FoodDetailsHeader,
  FoodDetailsInfo,
  StyledFoodDetails,
} from "./styled"
import { BackButton } from "components/Common/BackButton"
import Button from "components/Buttons/Button"
import { useState } from "react"
import ChevronLeftBtn from "components/Icons/ChevronLeftBtn"
import useEdamaForm from "features/food/hooks/edamaFood/useEdamaDetailsForm"
import EdamaNameAndPortion from "../share/EdamaNameAndPortion"
import FoodImage from "../share/FoodImage"
import AppStyleCtaBox from "components/Common/AppStyleCtaBox"
import { TopNavWrapper } from "components/Layouts/TopNavWrapper"
import NutrientInformation from "../share/NutrientInformation"
import { IRecentIngredient } from "model/food/types/recentIngredient.types"
import { IEdamaIngredientOption } from "model/food/types/edama.types"
import { getEdamaIngredientOptionFromRecentIngredient } from "model/food/utils/getPayloads/getRecentIngredientPayload"

interface IProps {
  ingredient: IRecentIngredient
  onBack: () => void
  onAdd: (ingredient: IEdamaIngredientOption) => void
}

const RecentIngredientDetails = (props: IProps) => {
  const { onBack, ingredient, onAdd } = props
  const { edama, onPortionChange, onUnitChange } = useEdamaForm(ingredient)
  const [isPortionValid, setIsPortionValid] = useState(true)

  const onPortionChangeHandler = (value: number) => {
    onPortionChange(value)
    setIsPortionValid(true)
  }

  const handleAdd = () => {
    // Convert to IEdamaIngredientOption with current portion/unit values
    const ingredientOption: IEdamaIngredientOption = {
      ...getEdamaIngredientOptionFromRecentIngredient(ingredient),
      // Override with the updated values from the form
      portion: edama.portion,
      unit: edama.unit,
      calorie: edama.calorie,
      protein: edama.protein,
      fat: edama.fat,
      carbohydrate: edama.carbohydrate,
      gram: edama.gram,
    }
    onAdd(ingredientOption)
    onBack()
  }

  return (
    <StyledFoodDetails>
      <FoodDetailsBody>
        <FoodImage previewImageUrl={ingredient.previewImageUrl}>
          <TopNavWrapper>
            <FoodDetailsHeader>
              <BackButton onClick={onBack}>
                <ChevronLeftBtn />
              </BackButton>
            </FoodDetailsHeader>
          </TopNavWrapper>
        </FoodImage>

        <FoodDetailsInfo>
          <EdamaNameAndPortion
            edama={edama}
            unitValue={edama.unit}
            portionValue={edama.portion}
            onPortionChange={onPortionChangeHandler}
            onUnitChange={onUnitChange}
            unitOptions={edama.units}
            setIsPortionValid={setIsPortionValid}
            calories={edama.calorie}
            gram={edama.gram}
          />

          <NutrientInformation entry={edama} />
        </FoodDetailsInfo>
      </FoodDetailsBody>

      <AppStyleCtaBox>
        <Button
          onClick={handleAdd}
          disabled={!isPortionValid}
          style={{ width: "100%" }}
          $type="primary"
        >
          Add this item
        </Button>
      </AppStyleCtaBox>
    </StyledFoodDetails>
  )
}

export default RecentIngredientDetails
